import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './index.scss';

export default function RequestApproval(props) {
  const onNotesChange = (event) => {
    props.onChange({ notes: event.target.value });
  };

  return (
    <div className="mindbody-success">
      <div className="sw-summary">
        <div className="sw-summary__heading">
          {props.softwareRequest.bookingSW}
        </div>
        <div className="sw-summary__heading sw-summary__heading--sub">
          {props.softwareRequest.siteLink}
        </div>
        <div className="sw-summary__value">
          {props.softwareRequest.studioName}
        </div>
        <div className="sw-summary__value">
          {props.softwareRequest.studioAddress}
        </div>
        <div className="sw-summary__value">
          Username: {props.softwareRequest.login}
        </div>
        <div className="sw-summary__value">
          Password: {props.softwareRequest.password}
        </div>
        <div className="sw-summary__value">
          Status: {props.softwareRequest.status}
        </div>
      </div>
      <div>
        <p className="mindbody-success__message">
          Please click on approve only after manual verification
        </p>
      </div>
      <div className="mindbody-success__form">
        <textarea
          name="notes"
          placeholder="Notes"
          onChange={onNotesChange}
          value={props.data.notes}
          className={classnames({ 'has-error': props.errors.notes })}
        />
        <div className="message message--error">
          {props.errors.notes}
        </div>
      </div>
      <div className="mindbody-success__actions">
        <button
          type="button"
          className="btn btn--secondary btn--lg"
          onClick={props.onCancel}
        >
          Decline
        </button>
        <button
          type="button"
          className="btn btn--primary btn--lg"
          onClick={props.onApprove}
        >
          Approve
        </button>
      </div>
    </div>
  );
}

RequestApproval.defaultProps = {
  onCancel: () => {},
  onApprove: () => {},
  onChange: () => {},
  data: {
    notes: '',
  },
  errors: {
    notes: '',
  },
};

RequestApproval.propTypes = {
  onCancel: PropTypes.func,
  onApprove: PropTypes.func,
  onChange: PropTypes.func,
  softwareRequest: PropTypes.shape({
    bookingSW: PropTypes.string,
    siteLink: PropTypes.string,
    studioName: PropTypes.string,
    studioAddress: PropTypes.string,
    login: PropTypes.string,
    password: PropTypes.string,
    isApproved: PropTypes.bool,
    status: PropTypes.string,
  }).isRequired,
  data: PropTypes.shape({
    notes: PropTypes.string,
  }),
  errors: PropTypes.shape({
    notes: PropTypes.string,
  }),
};
